import { ApolloError } from '@apollo/client';
import { PersonaMessages } from '@bechtel/client-common';
import {
  Box,
  Button,
  ButtonAppearance,
  Modal,
  ModalBody,
  ModalClose,
  ModalFooter,
  ModalHeader,
  ModalSize,
  Text,
  theme,
} from '@bechtel/gds';
import { AssignCommodityCrewMembersError, CommodityAssignmentError } from '@bechtel/types';
import { t, Trans } from '@lingui/macro';
import { useLingui } from '@lingui/react';
import { map } from 'lodash';
import { FC } from 'react';
import { AssignCommodityCrewMembersErrorProps } from './types';

const getErrorMessage = (commodityAssignmentError: CommodityAssignmentError) => {
  switch (commodityAssignmentError.error) {
    case AssignCommodityCrewMembersError.INVALID_COMMODITY_ID:
      return <Trans>Invalid Commodity Id.</Trans>;
    case AssignCommodityCrewMembersError.INVALID_CREW_MEMBER_ID:
      return <Trans>Invalid Crew Member Id.</Trans>;
    case AssignCommodityCrewMembersError.SERVICE_PROXY_ERROR:
      return <Trans>Service Proxy Error.</Trans>;
    case AssignCommodityCrewMembersError.ASSIGN_COMMODITY_ERRORRED:
      return <Trans>Assign Commodity Error.</Trans>;
    case AssignCommodityCrewMembersError.MISSING_REQUIRED_PERMISSION:
      return <Trans>Missing Required Permission.</Trans>;
    default:
      return <Trans>An error has occured. Please click close button and try again.</Trans>;
  }
};

export const AssignCommodityCrewMembersErrorModal: FC<AssignCommodityCrewMembersErrorProps> = ({
  commodityAssignmentErrors,
  close,
}) => {
  const { i18n } = useLingui();
  return (
    <Modal visible size={ModalSize.DEFAULT} style={{ width: '552px', height: '275px' }}>
      <ModalHeader title={t`Assign Commodity Error`}>
        <ModalClose onClick={close}></ModalClose>
      </ModalHeader>
      <ModalBody>
        <Box p={{ sm: '500' }} flexDirection={{ sm: 'column' }}>
          {commodityAssignmentErrors instanceof ApolloError && (
            <Box p={{ sm: '500' }}>
              <Text>
                <Trans>Network error has occured.Please close button and try again.</Trans>
              </Text>
            </Box>
          )}
          {commodityAssignmentErrors instanceof Array &&
            map(commodityAssignmentErrors, (error: CommodityAssignmentError, index) => {
              return (
                error && (
                  <Box
                    key={index}
                    css={{
                      borderBottom: commodityAssignmentErrors?.length > 1 ? `1px solid ${theme.colors.grey[300]}` : '',
                      width: '100%',
                    }}
                  >
                    <Box justifyContent={{ sm: 'space-between' }} p={{ sm: '500' }}>
                      {error?.persona && (
                        <Box mr={{ sm: '200' }}>
                          <Text size="500" weight="600">
                            {i18n._(PersonaMessages[error?.persona])} -
                          </Text>
                        </Box>
                      )}
                      <Box ml={{ sm: '200' }}>
                        <Text>{getErrorMessage(error)}</Text>
                      </Box>
                    </Box>
                  </Box>
                )
              );
            })}
        </Box>
      </ModalBody>
      <ModalFooter>
        <Box justifyContent={{ sm: 'flex-end' }}>
          <Box mr={{ sm: '400' }}>
            <Button appearance={ButtonAppearance.SECONDARY} onClick={close}>
              <Trans>Close</Trans>
            </Button>
          </Box>
        </Box>
      </ModalFooter>
    </Modal>
  );
};
